import type { StationeryTemplateCategoryEnum } from '@graphql/generated-base';
import { createTelemetry, createTelemetryObject } from '@shared/core';

const ACTION_CATEGORY = 'marketing.messaging.card';

export type CardDraftCreatedPageValue = 'pdpModal' | 'signupFlow';

export type CardDraftCreatedFormat = 'paper' | 'premiumDigital' | 'basicDigitalV2';

interface CardDraftCreatedArgs {
  page: CardDraftCreatedPageValue;
  themeId: string;
  stationeryTemplateCategory: StationeryTemplateCategoryEnum;
  format: CardDraftCreatedFormat;
  isDigital: boolean;
  isPremiumDesign: boolean;
  cardWidthInches?: number;
  cardHeightInches?: number;
}

const publicShopTelemetry = createTelemetryObject({
  pages: {
    createAccount: () => ({
      category: 'PublicCardShop',
      page: 'signup',
      pagePrefix: 'marketing',
    }),
    signIn: () => ({
      category: 'PublicCardShop',
      page: 'login',
      pagePrefix: 'marketing',
    }),
    createWeddingForm: () => ({
      category: 'PublicCardShop',
      page: 'weddingDetailsForm',
      pagePrefix: 'marketing',
    }),
    forgotPassword: () => ({
      category: 'PublicCardShop',
      page: 'forgotPassword',
      pagePrefix: 'marketing',
    }),
  },

  actions: {
    inputHandler: (fieldIdentifier: string, inputAction: 'onFocus' | 'onChange') => ({
      action: 'FormFieldInteracted',
      category: ACTION_CATEGORY,
      extraInfo: {
        name: fieldIdentifier,
        inputAction,
      },
    }),
    createOrSignupCtaClicked: (form: 'createAccount' | 'signIn') => ({
      action: 'CreateWeddingCTAClicked',
      category: 'PublicCardShop',
      extraInfo: {
        CtaName: 'EmailPassword',
        form,
      },
    }),

    cardDraftCreated: ({ page, ...extraInfo }: CardDraftCreatedArgs) => ({
      category: ACTION_CATEGORY,
      action: 'CardDraftCreated',
      page,
      extraInfo: extraInfo,
    }),
  },
});

const { TelemetryProvider: PublicCardShopTelemetryProvider, useTelemetry: usePublicCardShopTelemetry } = createTelemetry(publicShopTelemetry);

export { PublicCardShopTelemetryProvider, usePublicCardShopTelemetry };
